module.exports = __webpack_public_path__ + "img/emoji-coins-240x240.ed6aa0f9.png";